<template>
  <el-row>
    <div
      v-loading="loading"
      v-if="loading"
      class="loading"
    />
    <RelatorioTable v-else :filtros="filtros" />
  </el-row>
</template>

<script>
import RelatorioTable from './RelatorioTable'

export default {
  name: "RelatorioStatus",
  components: {
    RelatorioTable
  },
  props: {
    filtros: {
      type: Object,
      default: () => ({}), // Filtros recebidos do componente pai
    },
  },
  data () {
    return {
      tableData: [],
      loading: false,
      statusOption: [{
        value: 'processando',
        label: 'Processando'
      }, {
        value: 'finalizado',
        label: 'Finalizado'
      }, {
        value: 'aguardando',
        label: 'Aguardando'
      }, 
      {
        value: 'erro',
        label: 'Erro'
      }]
    };
  },
}
</script>

<style lang="scss" scoped>
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
}

.el-col {
  margin-bottom: 5px;
  &:last-child {
    margin-bottom: 0;
  }
}

.loading {
  height: 10vh;
}
</style>
